import { css } from "styled-components";

export const ghostLinkStyle = css`
  background-color: transparent !important;
  border: 1px solid transparent;
  color: var(--button-ghost-link);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-small);

  svg path {
    fill: transparent !important;
    stroke: var(--button-ghost-link) !important;
  }

  &:hover {
    background-color: transparent !important;
    border: 1px solid transparent !important;
    color: var(--button-ghost-link-hover) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--button-ghost-link-hover) !important;
    }
  }

  &:focus {
    outline: none !important;
    background-color: transparent !important;
    border: 1px solid transparent !important;
    color: var(--button-ghost-link) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--button-ghost-link) !important;
    }
  }

  &:focus-visible {
    outline: 1px solid var(--button-ghost-focused-border) !important;
    box-shadow: 0px 0px 0px 2px var(--button-focused-shadow) !important;
  }

  &:active {
    background-color: transparent !important;
    border-color: transparent !important;
    color: var(--button-ghost-link-hover) !important;
  }

  &[disabled] {
    background-color: transparent !important;
    border: 1px solid transparent;
    color: var(--button-ghost-link) !important;
    opacity: 0.7;

    &:hover {
      background-color: transparent !important;
      border: 1px solid transparent;
      color: var(--button-ghost-link) !important;
      opacity: 0.7;

      svg path {
        fill: transparent !important;
        stroke: var(--button-ghost-link);
      }
    }
  }
`;
